import { Box, Flex, Stack, Text } from '@chakra-ui/react';
import dayjs from 'dayjs';
import { Popover } from '../../../components/Popover';

const SingleGuest = (props) => {
  const { name, endDate, allowCompany } = props

  return (
    <Box p='20px' borderRadius='10px' boxShadow='sm'>
      <Flex justify='space-between' align='center'>
        {/*<Avatar name='Kent Dodds' src='https://bit.ly/kent-c-dodds' />*/}

        <Stack fontSize='0.8rem'>
          <Text fontSize='1.1rem' fontWeight='500' color='#614385'>
            {name}
          </Text>
          <Text>Last day of visit {dayjs(endDate).format('DD/MMM/YYYY')}</Text>
          <Text m='0 !important'>
            {allowCompany ? 'With Company' : 'Without Company'}
          </Text>
        </Stack>
        <Box alignSelf={'flex-end'}>
          <Popover {...props}/>
        </Box>
      </Flex>
    </Box>
  );
};

export default SingleGuest;
